export enum ClassType {
  PRIVATE = 'Private',
  GROUP = 'Group',
  HYBRID = 'Hybrid',
}



// WEBPACK FOOTER //
// ./ts/app/shared/types/class-types.enum.ts